import { render } from "./FooterLogin.vue?vue&type=template&id=72cddae6&scoped=true"
import script from "./FooterLogin.vue?vue&type=script&lang=js"
export * from "./FooterLogin.vue?vue&type=script&lang=js"

import "./FooterLogin.vue?vue&type=style&index=0&id=72cddae6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-72cddae6"

export default script